import { createPortal } from 'react-dom'
import React, { useContext } from 'react'
import { useLang } from '_metronic/i18n/Metronici18n'
import { QuotationFormContext } from '../Context'
import { Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'

interface Props {
	url: string
}

const QuotationURL: React.FC<Props> = ({ url }) => {
	const currentLanguage = useLang()
	const modalsRoot = document.getElementById('root-modals') || document.body
	const { showQuotationUrlModal, setShowQuotationUrlModal } = useContext(QuotationFormContext)

	const onCopy = () => {
		navigator.clipboard.writeText(url)
		toast.success(currentLanguage === 'en' ? 'Copied to clipboard' : 'คัดลอกลิงก์เรียบร้อยแล้ว')
	}

	return createPortal(
		<Modal
			id="document_quotation_form_quotation_url_modal"
			size="sm"
			tabIndex={-1}
			aria-hidden="true"
			dialogClassName="modal-dialog modal-dialog-centered mw-400px"
			show={showQuotationUrlModal}
			onHide={() => {
				setShowQuotationUrlModal(false)
			}}
			backdrop={true}>
			<div className="modal-content">
				<div className="modal-body py-lg-10 px-lg-10 min-h-100px">
					<h1 className="text-kumopack-grey-900 text-center">
						{currentLanguage === 'en' ? 'Quotation URL' : 'ลิงก์ใบเสนอราคา'}
					</h1>

					<div className="mt-10 card min-h-100px">
						<div className="card-body h-100 p-0">
							<div className="d-flex justify-content-center align-items-center h-100">
								<div className="d-flex flex-column align-items-center">
									<div className="text-center mt-2">
										<a
											href={url}
											target="_blank"
											rel="noreferrer"
											className="text-kumopack-secondary-700 fw-bold text-decoration-underline">
											{url}
										</a>
									</div>

									<div className="d-flex flex-row mt-5" style={{ gap: '12px' }}>
										<button
											className="btn btn-sm white-button text-kumopack-grey-900 fw-bold"
											type="button"
											onClick={() => {
												setShowQuotationUrlModal(false)
											}}>
											{currentLanguage === 'en' ? 'Close' : 'ปิด'}
										</button>
										<button
											className="btn btn-sm btn-kumopack-secondary-700 text-kumopack-base-white fw-bold"
											onClick={onCopy}
											type="button"
											data-kt-menu-trigger="click">
											{currentLanguage === 'en' ? 'Copy' : 'คัดลอก'}
										</button>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</Modal>,
		modalsRoot
	)
}

export default QuotationURL
